module.exports = "<div class=\"modal-header\">\n    <h4 class=\"modal-title\">Hi there!</h4>\n    <button type=\"button\" class=\"close\" aria-label=\"Close\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n  </div>\n  <div class=\"modal-body\">\n    <p>Hello</p>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-outline-dark\">Close</button>\n  </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/client/trans-other-details/trans-other-details.component.html
// module id = ./src/app/client/trans-other-details/trans-other-details.component.html
// module chunks = main